import { useState, useEffect, useCallback } from "react";

const useFreeAmountDelivery = () => {
  const [freeAmountDeliveryData, setFreeAmountDelivery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorFreeAmount, setError] = useState(null);

  const fetchFreeAmountDeliveryData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://backend.nuhababy.com/getFreeAmountDelivery"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setFreeAmountDelivery(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFreeAmountDeliveryData();
  }, [fetchFreeAmountDeliveryData]);

  return {
    freeAmountDeliveryData,
    loading,
    errorFreeAmount,
    refetch: fetchFreeAmountDeliveryData, // ✅ added
  };
};

export default useFreeAmountDelivery;
